export default {
  title: 'Nieuw merk',
  tabs: {
    general: 'Algemeen',
    branding: 'Branding',
    scripts: 'Scripts',
    tracking: 'Tracking',
    domain: 'Domein',
  },
  fields: {
    name: {
      label: 'Naam',
      placeholder: 'Merknaam',
    },
    slug: {
      label: 'Subdomein',
      placeholder: 'Subdomein van merk',
      hint: 'Kleine letters, cijfers en koppeltekens. Samen met het shopdomein vormt dit het shopadres.',
      preview: 'Shopadres: {{url}}',
      availability: {
        taken: 'Een ander merk gebruikt dit subdomein al op dit shopdomein.',
        reserved: 'Dit subdomein is gereserveerd. Kies een ander.',
        invalid_label:
          'Op dit shopdomein mag het subdomein alleen kleine letters, cijfers en koppeltekens bevatten, moet het met een letter of cijfer beginnen en eindigen en mag het hoogstens 63 tekens lang zijn.',
        taken_elsewhere: 'Een merk op een ander shopdomein gebruikt dit subdomein al. Kies een ander.',
        format: 'Gebruik alleen letters, cijfers, koppeltekens en underscores.',
        unavailable: 'Dit subdomein is niet beschikbaar. Kies een ander.',
      },
    },
    shop_domain_id: {
      label: 'Shopdomein',
      placeholder: 'Selecteer een shopdomein',
      move_warning: {
        title: 'Dit wijzigt het winkeladres dat klanten gebruiken',
        description:
          'Na het opslaan staat de winkel op {{url}}. QR-codes, flyers en links die al met het oude adres zijn gedrukt of gedeeld, werken dan niet meer.',
      },
    },
    lieferando_url: {
      label: 'Lieferando URL',
      placeholder: 'URL van het restaurant in Lieferando',
    },
    primary_color: {
      label: 'Primaire kleur',
    },
    logo: {
      label: 'Logo',
    },
    image: {
      label: 'Afbeelding',
    },
    companies: {
      label: 'Restaurants',
    },
    noscripts: {
      description: 'Code direct na opening body invoegen',
    },
    facebook_pixel: {
      label: 'Facebook Pixel',
    },
    facebook_conversion_api_access_token: {
      label: 'Facebook Conversion Access Token',
    },
    google_analytics_id: {
      label: 'Google Analytics ID',
    },
    google_ads_conversion_label_id: {
      label: 'Google Ads conversielabel',
    },
    // Named in the modal's error summary when the domain is refused.
    online_shop_domain: {
      label: 'Eigen domein voor de webshop',
    },
  },
  buttons: {
    save: 'Opslaan',
    close: 'Sluiten',
    sync_from_lieferando: 'Synchroniseren vanuit Lieferando',
  },
  toasts: {
    changes_saved_successfully: 'Wijzigingen zijn succesvol opgeslagen!',
    failed_to_update_company_slug: 'Slug bijwerken voor {{name}} mislukt',
    failed_to_sync_lieferando: 'Synchroniseren vanuit Lieferando mislukt',
    successfully_synced_lieferando: 'Gegevens succesvol gesynchroniseerd vanuit Lieferando',
    failed_to_load_shop_domains: 'Kan de shopdomeinen niet laden.',
    logo_file_too_large: 'Het logo is te groot. De maximale grootte is {{max}} MB.',
    logo_dimensions_too_large: 'Het logo is te groot. Breedte en hoogte mogen maximaal {{max}} pixels zijn.',
  },
};
